import api from "../http/api";

export const readCustomizerDashboardByUser = async (userId, institutionId) => {
  try {
    const response = await api.client.get(`api/v1/ReadCustomizerDashboardByUser`, {
      params: {
        userId: userId
      },
      headers: {
        InstitutionId: institutionId
      }
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw new Error("Falha ao buscar dashboard customizado");
  }
};

export const readAvailableIndicators = async () => {
  try {
    const response = await api.client.get(`api/v1/ReadAvailableIndicators`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar indicadores:", error);
    return [];
  }
};

export const previewIndicator = async (params) => {
  try {
    const response = await api.client.post(`api/v1/customizer/indicators/preview`, params);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar preview do indicador:", error);
    throw error;
  }
};

export const createCustomizerDashboard = async (params, institutionId) => {
  try {
    const response = await api.client.post(`api/v1/CreateCustomizerDashboard`, params, {
      headers: {
        InstitutionId: institutionId
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar dashboard:", error);
    throw error;
  }
};

export const getDashboardData = async (dashboardId, userId, institutionId, startDate, endDate, filters = {}) => {
  try {
    const params = {
      userId
    };
    
    // Adiciona os parâmetros de data se existirem
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    // Adiciona os filtros se existirem
    if (filters.knowledgeArea) {
      params.knowledgeArea = filters.knowledgeArea;
    }
    if (filters.discipline) {
      params.discipline = filters.discipline;
    }
    if (filters.courseType) {
      params.courseType = filters.courseType;
    }
    if (filters.locality) {
      params.locality = filters.locality;
    }
    if (filters.modality) {
      params.filtermodality = filters.modality;
    }
    if (filters.shift) {
      params.filtershift = filters.shift;
    }
    
    const response = await api.client.get(`api/v1/customizer/dashboards/${dashboardId}/data`, {
      params,
      headers: {
        InstitutionId: institutionId
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados do dashboard:", error);
    throw error;
  }
};

export const deactivateCustomizerDashboard = async (dashboardId, deactivatedByUserId) => {
  try {
    const response = await api.client.post(`api/v1/DeactivateCustomizerDashboard`, {
      dashboardId,
      deactivatedByUserId
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao desativar dashboard:", error);
    throw error;
  }
};

export const copyCustomizerDashboard = async (sourceDashboardId, targetUserId, copiedByUserId, newName) => {
  try {
    const response = await api.client.post(`api/v1/CopyCustomizerDashboard`, {
      sourceDashboardId,
      targetUserId,
      copiedByUserId,
      newName
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao copiar dashboard:", error);
    throw error;
  }
};

export const updateCustomizerDashboard = async (params, institutionId) => {
  try {
    const response = await api.client.put(`api/v1/UpdateCustomizerDashboard`, params, {
      headers: {
        InstitutionId: institutionId
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar dashboard:", error);
    throw error;
  }
};

